const publicModule = {
  title: "Alarm type",
  pageTitle: "Vehicle operation service management platform",
  resMsg: "Verification failed. Please login again",
  cancel: "Cancel",
  define: "Confirm",
  close: "Close",
  startUp: "Start-up",
  tips: "Tips",
  deleteTips: "Please check the items to be deleted",
  ordinaryDeleteTips: "Ordinary users can only delete user-defined items",
  administratorsDeleteTips: "Administrators can only delete routine maintenance and other maintenance",
  usersDeleteTips: "Users can only delete self built projects",
  deleteItemTips: "Do you want to delete options?",
  updateTips: "Please check the items to be updated",
  viewTips: "Please select the item you want to view",
  createTips: "Please select the items that need to be added",
  noSelectTips: "Please select the vehnoSelectTipsicle to bind",
  operationTips: "Please select the item you want to operate",
  createSuccess: "Successfully create",
  updateSuccess: "Successfully update",
  deleteSuccess: "Successfully delete",
  setSuccess: "Set up success",
  add: "Add",
  delete: "Delete ",
  update: "Update",
  create: "Add",
  search: "Search",
  clear: "Clear",
  more: "More",
  open: "Expand",
  packUp: "Shotten",
  note: "Remark",
  others: "Other",
  operation: "Operation",
  view: "View",
  revoke: "Cancel",
  createTime: "Create Time",
  usertypeList: {
    internalUsers: "Internal users",
    externalUsers: "External users"
  },
  startTime: "Start time",
  endTime: "End time",
  quickQuery: "Quick query",
  quickQueryLabelWidth: "90px",
  organizationName: "Organization name",
  licensePlate: "License plate",
  licensePlatewidth1: "95px",
  importDialog: {
    title: "Import",
    file: "File",
    browse: "Browse",
    note: "Note: if the uploaded files need to be re-selected before uploading",
    downloadTemplate: "Download the template",
    success: "Success",
    uploadSuccess: "File uploaded successfully",
    selectFile: "Please select upload file",
    restFile: "This file has been uploaded please re-select the upload file"
  },
  reset: "Reset",
  import: "Import",
  basicMode: "Basic mode",
  default: "default",
  green: "Green",
  modelName: "Model name",
  other: {
    yes: "Yes",
    no: "No",
    off:'Engine off',
    on:'Engine on',
    dataTime: "Reported data time",
    area: "Use area",
    voltage: "Constant voltage",
    isDriving: "Driving or not",
    can: "CAN data",
    gpsMileage: "GPS mileage",
    signalStrength: "Signal strength",
    speed: "Vehicle speed",
    vSpeed: "Speed",
    noGroup: "No group",
    finallyData: "Last reported data before vehicle offline",
    textIndent: "15px"
  },
  timeError: "Start time cannot be later than end time， please reselect it",
  unbind: "Unbundling",
  bind: "Binding",
  gender: "Gender",
  male: "Male",
  female: "Female",
  userName: "User name",
  mobile: "Mobile No",
  enable: "Enable",
  ban: "Disable",
  all: "All",
  uploadImageFailed: "Picture upload failed， please try again later!",
  viewDetail: "Information",
  defaultpassword: "Default password:12345678",
  remarkDescription: "You can type up to 200 words",
  uploading: "File up and down",
  obdCode: "OBD code",
  lengthMessage: "Character length must not exceed",
  expirationTime: "Expire Date",
  driveSmallPlate: "MCB Code",
  upgradeTime: "Upgrade time",
  maxValue: "Max",
  minValue: "Min",
  checkCarSelect: "Select vehicle",
  chose: "Chose",
  choseObd: "OBD Authorization",
  setting: "Setting",
  terminal: "Terminal number",
  firmwareVersion: "Firmware version",
  mpuVersion: "MPU version",
  changeAlarm: "Change alarm",
  wakeUpOnTime: "Wake up on time",
  cancelTaskTips: "Do you want to cancel the task?",
  cancelAllTaskTips: "Do you want to cancel the selected task?",
  clickCancle: "Click to cancel",
  fail: "Fail",
  success: "Succss",
  noResponse: "No response",
  description: "describe",
  sim: "Device SIM No.",
  iccid: "ICCID",
  simWidth: "120px",
  noSetting: "Not set",
  opens: "Open",
  operationStatus: "Operation status",
  operTarget: "Operation Target",
  register: "Register",
  forget: "Forget password",
  changePassword: "Change password",
  changeMobile: "Change mobile number",
  account: "Account",
  vehicle: "Vehicle",
  fence: "Fence",
  newCreate: "Create",
  edit: "Edit",
  cancelTask: "Cancel task",
  noCommad: "Please select command item",
  normalMode: "Normal operation mode",
  busSleep: "Bus sleep",
  lockCarOpen: "Lock car",
  cancelLockCar: "Cancel lock",
  commandVehicle: "Command OBD Devices",
  command: "Command package",
  taskInformation: "Task information",
  noNormalMode: "Please select sleep mode",
  confirmUrl: "Please check the connection address of the OBD device carefully to prevent the connection loss of the OBD device. ",
  IPorDomain: "IP or Domain",
  export: "Export",
  obdNote: "Note: only the OBD device number at the beginning of v2a2 can select the driving board.",
  formLoadFailed: "Failed to load the form",
  baseInfo: "Basic information",
  totalmileage:"Total mileage",
  duration:"Duration",
  consumptionrate:"Consumption Rate",
  averagespeed:"Average speed",
  totalidletime:"Total Idle Time",
  vehicletype:"Vehicle type",
  currentvehiclestatus:"Current vehicle status",
  models:"Models",
  latitude:"latitude",
  longitude:"longitude",
  maxSpeed:"max speed",
  startldletime:"Start ldle time",
  endldletime:"End ldle time",
  totalldletime:"Total Idle time",
  Percentpertrip:"Percentage per trip",
  Totalfueluse:"Total fuel use",
  averageconsumption:"Average consumption",
  lastlocation:"Last location",
  lasttime:"Last time",
  vibrationlocation:"Vibration location",
  vibrationtime:"Vibration time",
  ignitionlocation:"Ignition location",
  ignitiontime:"Ignition time",
  overspeedtime:"Over Speed time",
  timesofoverspeed:"Times of Over Speed",
  geofencename:"Geo fence name",
  status:"Status (inside/outside Geofence)",
  entertime:"Enter time",
  durationsig:"Duration (Stay inside Geofence)",
  exittime:"Exit time",
  durationsog:"Duration (Stay Outside Geofence)",
  faultgroup:"Fault group",
  faultcode:"Fault code",
  faultdescription:"Fault Description",
  diagnosticstartdatatime:"Diagnostic Start date/time",
  diagnosticenddatatime:"Diagnostic End date/time",
  carnum:"Total Number of Car",
  offlinenum:"Number of Device Offline",
  parkengineon:"Number of Park Engine On",
  parkengineoff:"Number of Park Engine Off",
  normalspeeddrive:"Number of Normal Speed Driving",
  overspeeddrive:"Number of Over Speed Driving",
  offline:"ออฟไลน์",
  online:"ออนไลน์",
  maintenance:"Maintenance",
  repair:"Repair"
  
} 
export default publicModule